import React, { useState } from "react";
import "../styles/Register.css";
import registerImg from "../assets/img/bg_1.jpg";
import { FaPaperPlane } from "react-icons/fa";
import { toast } from "react-toastify";
import { resetPassword } from "../api/authApi";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const location = useLocation();
  const emailFromState =
    location.state?.email ||
    new URLSearchParams(location.search).get("email") ||
    "";

  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      setLoading(true);
      const response = await resetPassword({
        email: emailFromState,
        otp,
        password: newPassword,
        confirmPassword,
      });

      toast.success(response.data.message || "Password reset successful!");
      setTimeout(() => {
        navigate("/login"); 
      }, 1500);
    } catch (error) {
      console.error("Reset password error:", error);
      toast.error(
        error?.response?.data?.message || "Failed to reset password.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = () => {
    toast.info("OTP resent to your email.");
  };

  return (
    <div className="register-wrapper">
      <div className="register-bg">
        <img src={registerImg} alt="Reset Password" />
      </div>

      <div className="register-form-container flip-in-left">
        <h3 className="form-title">Reset Password</h3>
        <form className="register-form" onSubmit={handleSubmit}>
          {/* Email (Read-only) */}
          <div className="floating-input">
            <input type="email" value={emailFromState} readOnly />
            <label>Email</label>
          </div>

          {/* OTP */}
          <div
            className="floating-input d-flex align-items-center"
            style={{ position: "relative" }}
          >
            <input
              type="text"
              id="otp"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            <label htmlFor="otp">Enter OTP</label>
            <span
              className="resend-otp"
              onClick={handleResendOtp}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "12px",
                cursor: "pointer",
              }}
            >
              Resend OTP
            </span>
          </div>

          {/* New Password */}
          <div className="floating-input">
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <label htmlFor="newPassword">New Password</label>
          </div>

          {/* Confirm Password */}
          <div className="floating-input">
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <label htmlFor="confirmPassword">Confirm Password</label>
          </div>

          {/* Submit Button */}
          <div className="text-right mt-3">
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "..." : <FaPaperPlane />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
